import { Link } from "@/i18n/navigation";
import { urlFor } from "@/lib/image";
import { ArticleInfo } from "@/types";

import ArrowRightIcon from "@/components/icons/arrow-right.svg";

interface PostGalleryProps {
  itemsPerRow: 1 | 2 | 3;
  itemWidth: 400;
  imageHeight: 275;
  articles: ArticleInfo[];
  readMoreLabel: string;
  showSummaries?: boolean;
  showMagazineLink?: boolean;
  gapX?: 20 | 40 | 60;
  gapY?: 20 | 30 | 40;
  applyGapYBeforeMagazineLink?: boolean;
}

export default function PostGallery(props: PostGalleryProps) {
  const itemWidth = Math.round(props.itemWidth);
  const imageHeight = Math.round(props.imageHeight);

  const itemsPerRowClasses = {
    1: "grid-cols-1",
    2: "grid-cols-1 md:grid-cols-2",
    3: "grid-cols-1 md:grid-cols-3",
  };

  const aspectRatios = {
    '16/11': "aspect-16/11",
    '10/13': "aspect-10/13",
  };

  const widthClasses = {
    400: 'w-[400px]',
  }

  const heightClasses = {
    275: 'h-[275px]'
  }

  const gapXClasses = {
    20: 'gap-x-5',
    40: 'gap-x-5 md:gap-x-10',
    60: 'gap-x-5 md:gap-x-10 lg:gap-x-[60px]',
  };

  const gapYClasses = {
    20: 'gap-y-5',
    30: 'gap-y-[30px]',
    40: 'gap-y-5 md:gap-y-10',
  };

  return (
    <div className={((props.applyGapYBeforeMagazineLink && props.gapY) ? gapYClasses[props.gapY] : "gap-5") + " flex flex-col"}>
      <div className={`w-full relative overflow-hidden grid ${itemsPerRowClasses[props.itemsPerRow]} ${props.gapX ? gapXClasses[props.gapX] : gapXClasses[20]} ${props.gapY ? gapYClasses[props.gapY] : gapYClasses[20]} items-start justify-between py-5 box-border text-2xl text-primary font-[Outfit]`}>
        {props.articles.map((a, i) => {
          return (
            <Link key={`blog-${i}`} href={a.articlePageUrl} className={`flex-1 overflow-hidden shrink-0 flex flex-col items-start gap-2.5`}>
              <img src={`${a.imgSrc}?w=${itemWidth * 2}&h=${imageHeight * 2}`} className="aspect-16/11 rounded-3xl w-full max-h-full overflow-hidden object-cover" width={itemWidth} height={imageHeight} />
              <div className="self-stretch leading-[28px] font-semibold text-wrap">{a.title}</div>
              {props.showSummaries && (<div className="self-stretch leading-[120%] text-wrap text-base">{a.intro}</div>)}
            </Link>
          )
        })}
      </div>
      {props.showMagazineLink && <div className="w-full relative overflow-hidden flex items-center justify-center p-2.5 box-border">
        <Link href="/blog">
          <button className="btn btn-secondary text-white rounded-full gap-1.5">
            {props.readMoreLabel}
            <ArrowRightIcon className="w-3.5 h-3.5 stroke-white" />
          </button>
        </Link>
      </div>}
    </div>
  );
}
